
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { getContactInfo, getSiteSettings } from '../../api/apiServices';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('idle');
  const [settings, setSettings] = useState(null);
  const [fetching, setFetching] = useState(false);

  const [contact, setContact] = useState([])
  const [contactId, setContactId] = useState(null);
  const [loading, setLoading] = useState(true);
    
      useEffect(() => {
          const fetchContact = async () => {
            try {
              const res = await getContactInfo();
      
              if (res?.data) {
                setContact(res.data);
                setContactId(res.data._id);
              }
            } catch (error) {
              console.error("Fetch Contact Error:", error);
            } finally {
              setLoading(false);
            }
          };
      
          fetchContact();
        }, []);

  
      useEffect(() => {
          const fetchSettings = async () => {
      try {
        const res = await getSiteSettings();
        if (!res?.data) return;
        setSettings(res.data);
      } catch {
        console.log("No site settings yet");
      } finally {
          setFetching(false);
      }
    };
    fetchSettings()
        }, []);

  return (
    <footer className="bg-[#f5f3fb] pt-12 sm:pt-16 lg:pt-20 pb-6 sm:pb-8 px-4 sm:px-6 lg:px-20">
      <div className="max-w-7xl mx-auto">
        {/* Top Row */}
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-10 sm:mb-16 gap-4 sm:gap-6">
          <Link to="/" className="flex items-center gap-2 sm:gap-3 cursor-pointer">
            {/* <img
              src={settings?.logo}
              alt="Hope Restored Logo"
              className="h-16 sm:h-20 w-auto object-contain"
            /> */}
            <span className="text-[#6a4bc3] font-bold text-lg sm:text-xl">{settings?.siteName}</span>
          </Link>
          <p className="text-gray-600 text-sm max-w-md">
            Restoring hope, rebuilding lives, one survivor at a time
          </p>
        </div>

        {/* Navigation Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 sm:gap-12 mb-10 sm:mb-16">
          {/* Get Help */}
          <div>
            <h4 className="text-gray-900 font-semibold mb-4 sm:mb-6 text-sm sm:text-base">Get Help</h4>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <Link to="/contact" className="text-gray-600 hover:text-[#c9a24d] transition-colors text-xs sm:text-sm cursor-pointer">
                  Crisis Support
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-600 hover:text-[#c9a24d] transition-colors text-xs sm:text-sm cursor-pointer">
                  Counseling Services
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-600 hover:text-[#c9a24d] transition-colors text-xs sm:text-sm cursor-pointer">
                  Legal Aid
                </Link>
              </li>
            </ul>
          </div>

          {/* Get Involved */}
          <div>
            <h4 className="text-gray-900 font-semibold mb-4 sm:mb-6 text-sm sm:text-base">Get Involved</h4>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <Link to="/volunteer" className="text-gray-600 hover:text-[#c9a24d] transition-colors text-xs sm:text-sm cursor-pointer">
                  Volunteer
                </Link>
              </li>
              <li>
                <Link to="/donate" className="text-gray-600 hover:text-[#c9a24d] transition-colors text-xs sm:text-sm cursor-pointer">
                  Donate
                </Link>
              </li>
              <li>
                <Link to="/volunteer" className="text-gray-600 hover:text-[#c9a24d] transition-colors text-xs sm:text-sm cursor-pointer">
                  Advocate
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-600 hover:text-[#c9a24d] transition-colors text-xs sm:text-sm cursor-pointer">
                  Partner With Us
                </Link>
              </li>
            </ul>
          </div>

          {/* About */}
          <div>
            <h4 className="text-gray-900 font-semibold mb-4 sm:mb-6 text-sm sm:text-base">About</h4>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <Link to="/about" className="text-gray-600 hover:text-[#c9a24d] transition-colors text-xs sm:text-sm cursor-pointer">
                  Our Story
                </Link>
              </li>
              
              <li>
                <Link to="/stories" className="text-gray-600 hover:text-[#c9a24d] transition-colors text-xs sm:text-sm cursor-pointer">
                  Impact Stories
                </Link>
              </li>
              
            </ul>
          </div>

          {/* Social & Copyright */}
          <div className="text-left sm:text-right">
            <p className="text-gray-700 text-sm mb-2">© 2026 {settings?.siteName}</p>
            <p className="text-gray-500 text-xs mb-4">All rights reserved</p>
            <div className="flex sm:justify-end gap-3">
              <a href={contact?.facebook} className="text-gray-600 hover:text-[#c9a24d] transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href={contact?.twitter} className="text-gray-600 hover:text-[#c9a24d] transition-colors cursor-pointer">
                <i className="ri-twitter-x-fill text-lg"></i>
              </a>
              <a href={contact?.instagram} className="text-gray-600 hover:text-[#c9a24d] transition-colors cursor-pointer">
                <i className="ri-instagram-fill text-lg"></i>
              </a>
              <a href={contact?.linkedin} className="text-gray-600 hover:text-[#c9a24d] transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Link */}
        <div className="mt-8 sm:mt-12 pt-6 sm:pt-8 border-t border-gray-300 text-center">
          <a
            href="https://dealdrivetechnology.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-500 hover:text-[#c9a24d] text-xs transition-colors cursor-pointer"
          >
            Dealdrive Technology
          </a>
        </div>
      </div>
    </footer>
  );
}
